const getUniqueValues = <E, K extends keyof E>(entities: E[], key: K): E[K][] =>
  entities
    .map((entity) => entity[key])
    .filter((id, index, theArray) => theArray.indexOf(id) === index);

export default getUniqueValues;
